// Copyright © 2023 Move Closer
import { StickyBarColor } from './StickyBar.contracts';
export const stickyBarConfig = {
    [StickyBarColor.Black]: 'bg-gray text-white',
    [StickyBarColor.Blue]: 'bg-blue text-white',
    [StickyBarColor.Brand]: 'bg-brand text-white',
    [StickyBarColor.Yellow]: 'bg-cta text-black',
    [StickyBarColor.Gray]: 'bg-gray-10 text-black',
    [StickyBarColor.Green]: 'bg-green text-white'
};
